<template>
  <el-dialog :title="$t('schedule.tips')" :visible.sync="dialogVisible" width="60%" height="50vh" :before-close="handleClose" :append-to-body='true' @open="getDetail" :center="true">
    <div class="dedialog">
      <el-tabs v-model="activeName" type="card">

        <el-tab-pane :label="$t('schdule.playList')" name="first">
          <el-table style="width: 100%" ref="multipleTable" :data="plan_list_data" height="90%" header-row-class-name="tableHead" :header-cell-style="{color:'black'}">
            <div v-for="(item,index) in planListTableHead" :key="index">
              <el-table-column :prop="item.column_name" :label="$t(item.column_comment)"></el-table-column>
            </div>
          </el-table>
        </el-tab-pane>

        <el-tab-pane :label="$t('schdule.terminalList')" name="second">
          <el-table style="width: 100%" ref="multipleTable" :data="device_list_data" height="90%" header-row-class-name="tableHead" :header-cell-style="{color:'black'}">
            <template v-for="(item,index) in deviceListTableHead">
              <el-table-column :prop="item.column_name" :label="$t(item.column_comment)" :key="index" v-if="item.column_name!='run_state'"></el-table-column>
              <el-table-column :prop="item.column_name" :label="$t(item.column_comment)" :key="index" v-if="item.column_name=='run_state'">
                <template slot-scope="scope">
                  <span v-if="scope.row.run_state==0" class="redfont">{{$t('schdule.offline')}}</span>
                  <span v-if="scope.row.run_state==7" class="greenfont">{{$t('terminal.runStatus')}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </el-tab-pane>

        <el-tab-pane :label="$t('schdule.releaseProp')" name="third">
          <el-table style="width: 100%" ref="multipleTable" :data="fabu_list_data" height="90%" header-row-class-name="tableHead" :header-cell-style="{color:'black'}">
            <template v-for="(item,index) in fabu_detail_Head">
              <el-table-column :prop="item.column_name" :label="$t(item.column_comment)" :key="index" v-if="item.column_name!='fabu_type'"></el-table-column>
              <el-table-column :prop="item.column_name" :label="$t(item.column_comment)" :key="index" v-if="item.column_name=='fabu_type'">
                <template slot-scope="scope">
                  <span v-if="scope.row.fabu_type==1">{{$t('schedule.timimgPlan')}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </el-tab-pane>

      </el-tabs>
      <footer class="detail_footer">
        <span>{{$t('schedule.pedReview')}}</span>
      </footer>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "PlanDetailDialog",
  props: {
    detailDialogVisible: {
      type: Boolean,
      default: false
    },
    detailId: {
      type: Number
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeName: 'first',
      plan_list_data: [],
      device_list_data: [],
      fabu_list_data: [],
      planListTableHead: [{
        column_name: "name",
        column_comment: "schedule.user"
      },
      {
        column_name: "group_name",
        column_comment: "schedule.structure"
      },
      {
        column_name: "template_name",
        column_comment: "terminal.temName"
      },
      {
        column_name: "create_time",
        column_comment: "terminal.createTime"
      }
      ],
      deviceListTableHead: [{
        column_name: "name",
        column_comment: "terminal.terminalName"
      },
      {
        column_name: "group_name",
        column_comment: "schedule.structure"
      },
      {
        column_name: "size_remark",
        column_comment: "schedule.resolution"
      },
      {
        column_name: "run_state",
        column_comment: "schedule.terminalState"
      },
      {
        column_name: "fabu_state",
        column_comment: "schedule.publishSate"
      }
      ],
      fabu_detail_Head: [{
        column_name: "fabu_no",
        column_comment: "schedule.playNo"
      },
      {
        column_name: "group_name",
        column_comment: "schedule.structure"
      },
      {
        column_name: "fabu_type",
        column_comment: "schedule.releaseType"
      },
      {
        column_name: "play_mode",
        column_comment: "schedule.planModole"
      },
      {
        column_name: "fabu_strategy",
        column_comment: "schedule.playStrategy"
      },
      {
        column_name: "fabu_time",
        column_comment: "schedule.releaseTim"
      },
      {
        column_name: "end_date",
        column_comment: "cscp1"
      }
      ]
    }
  },
  methods: {
    handleClose() {
      // 子组件调用父组件方法，并传递参数
      this.$emit('changeShow', 'false')
      this.dialogVisible = false
    },
    getDetail() {
      const group_ids = sessionStorage.getItem('group_ids');
      this.$http.post("/admin/fabu/detail", {
        //limit,
        group_ids,
        id: this.detailId
      }, info => {
        this.detail_data = info;
        this.plan_list_data = info.play
        this.device_list_data = info.device
        this.fabu_list_data = info.attr
        console.log(this.detail_data)
      });
    }
  },
  watch: {
    // 监听 addOrUpdateVisible 改变
    detailDialogVisible() {
      this.dialogVisible = this.detailDialogVisible
    },
  }
}
</script>

<style lang="scss" scoped>
.redfont {
  color: red;
}

.greenfont {
  color: green;
}
.detail_footer {
  text-align: center;
  font-size: 20px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0;
}
.dedialog {
  height: 40vh;
  position: relative;
}
</style>
